site.maxHeight = {
	init: function (selector) {
		if (!selector || $(selector).length === 0) return;
		//site.maxHeight.setHeight(selector);
		$(window).load(function() {
			site.maxHeight.setHeight(selector);
		});
		$(window).resize(function () {
			site.maxHeight.setHeight(selector);
		});
	},

	setHeight: function (selector) {
		$(selector).each(function () {
			$(this).css('max-height', $(this)[0].scrollHeight);
		});
	}
};



site.breadcrumbsDropdown = {
	init: function () {
		site.maxHeight.init('#breadcrumbs ul ul');
		$('.expand').on('click touchstart', function (e) {
			e.preventDefault();
			e.stopPropagation();

			var $this = $(this);
			if($this.hasClass('open')) {
				site.breadcrumbsDropdown.close(true);
			}
			else {
				site.breadcrumbsDropdown.open($this);
			}

			$('body.br-open').on('click touchstart', function (e) {
				site.breadcrumbsDropdown.close(true);
			});
		});
	},
	open: function(open) {
		site.breadcrumbsDropdown.close(true);
		var $body = $('body');
		var $this = open;
		$body.toggleClass('br-open');
		$this.toggleClass('open').next('ul.menu').toggleClass('open').parent('.children').toggleClass('open');
	},
	close : function(closing) {
		closing = closing || false;
		var $body = $('body');

		$body.removeClass('br-open');
		$('#breadcrumbs').find('.open').removeClass('open');

		if (closing) {
			$body.addClass('br-closing');
			setTimeout(function() {
				$('body').removeClass('br-closing');
			},400);
		}
	}
}
site.inits.push('site.breadcrumbsDropdown.init()');
